"use client";
import { useRouter } from "i18n/routing";
import { usePathname } from "next/navigation";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { Button } from "@ui/components/forms/button/Button";
import { Text } from "@ui/components/content/text/Text";
import { useStore } from "@store/store";
import { useEffect } from "react";

type PreviewModeProps = {
    preview: boolean;
};

const PreviewMode = ({ preview }: PreviewModeProps) => {
    const { push } = useRouter();
    const pathname = usePathname();
    const setPreviewMode = useStore((state) => state.setPreviewMode);
    useEffect(() => {
        setPreviewMode(preview);
    }, [preview, setPreviewMode]);

    const handleSubmit = () => {
        push(`/api/preview/clear?redirect=${encodeURI(pathname)}`);
    };

    if (!preview) return null;

    return (
        <Box
            position="fixed"
            zIndex={9999}
            color="white"
            backgroundColor="rgba(167, 8, 40, 0.75)"
            maxWidth={["100%", null, "300px"]}
            width={["100%", null, "300px"]}
            p={1}
            px={10}
            right={["0", null, "200px"]}
            bottom={0}
        >
            <Flex justifyContent="space-around" direction="row" alignItems="center" gap="10px">
                <Text fontWeight="bold" fontSize="desktopBodyTextSmall">
                    PREVIEW
                </Text>
                <Button onClick={handleSubmit} backgroundColor="rgba(167, 8, 40, 0.9)" px={10}>
                    Exit
                </Button>
            </Flex>
        </Box>
    );
};
export default PreviewMode;
